import { LessonActivity } from "modules/lesson/activity/activity.types"
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap"
  import React, { useEffect, useState } from "react"
import { LllNodeBranch } from "modules/lll/lll-node-branch"
import { lllLookupService } from "modules/lll/lll-lookup"
import { LllMetadata } from "modules/lll/lll-nodes"
import { LessonActivityModel } from "../../../modules/lesson/activity/lesson-activity"
import {formatIsoDate} from "../../../common/utils/date-utils"
import awicon from "../../../assets/images/services-icon/coin.png"
import { LllNextActivitySearcher } from "../../../modules/lll/lll-next-activity-searcher"


type LllActivityCardProp = {
  activity: LessonActivity,
  studentKey?: string,
  options?: {
    showStatus?: boolean
    showContextMenu?: boolean
    showDelete?: boolean
    index?: number
    onDelete?: () => Promise<void>
    showRollOverToNextSession?: boolean
    onRollOverToNextSession?: () => Promise<void>
    showRollOverFrom?: boolean
    showHighlight?: boolean
    onAddNextActivity?: () => unknown
    onAddNextActivityToHomework?: () => unknown
  },
  checkbox?: {
    checkable: boolean
    checked?: boolean
    onCheckedChanged?: () => unknown
  }
}

export const LllActivityCard = (props: LllActivityCardProp) => {

  const {options, activity, studentKey: activityStudentKey, checkbox} = props;
  const [lllNodeBranch, setLllNodeBranch] = useState<LllNodeBranch | null>(null);
  const [contextMenuOpen, setContextMenuOpen] = useState(false);
  const [hasNext, setHasNext] = useState(false);

  const activityModel = new LessonActivityModel(activity);
  const total_coins = LllMetadata.coinsPerActivity;

  useEffect(() => {
    async function getActivityTree(){
      await lllLookupService.getActivityTree();
      const _activityNode= lllLookupService.findNodeByFqn(activity.activity_ref_id!);
      const _branch = LllNodeBranch.createTo(_activityNode);

      const searcher = new LllNextActivitySearcher();
      const nextActivity = searcher.getNextActivity(_activityNode);
      setHasNext(!!nextActivity);
      setLllNodeBranch(_branch);
    }
    getActivityTree().then();
  }, [])


  function getHighlightColor(activityModel: LessonActivityModel) {
    if(!options?.showHighlight)
      return ""

    if(activityModel.isCompleted())
      return "activity-card-success"
    else
      return "activity-card-danger"

  }

  return <div className={`m-1 set1 bg-supermild ${getHighlightColor(activityModel)}`} style={{}}>
    <div className="d-flex justify-content-between">
      <div>
        {
          options?.showRollOverFrom && activityModel.getRollOverDate() !== null &&
            <span className="cs-txt-danger font-size-10 me-2">
              Rolled over from {formatIsoDate(activityModel.getRollOverDate())}
            </span>
        }

        {
          options?.showStatus &&
          <>
            { activityModel.isCompleted() &&
              <span className="text-success font-size-10 me-2">Completed</span>
            }
            {!activityModel.isCompleted() &&
              <span className="cs-txt-danger font-size-10 me-2">Incomplete</span>
            }
          </>
        }
      </div>

      {
        checkbox?.checkable &&
        <div>
          {
            (!activityStudentKey || activity.fk_student_key === activityStudentKey) &&
            <>
              <input
                type="checkbox"
                checked={checkbox.checked}
                onChange={checkbox.onCheckedChanged}
              />
            </>
          }
        </div>
      }
    </div>
    <p><b>{options?.index !== undefined ? options.index + 1 + ') ' : ''} LLL: {lllNodeBranch?.topicDisplay} </b></p>
    <div className="d-flex justify-content-between">
      <div className="align-items-center fw-400 font-size-12 text-dark">
        <div>{lllNodeBranch?.activityDisplay}</div>
        {options?.onAddNextActivity && hasNext && <>
          <div><span style={{borderRadius: '5px', backgroundColor: "#5b51ff", color: "#ffffff", padding: "0 4px"}}>next available</span></div>
        </>}
      </div>
      <div>
        {options?.showContextMenu &&
          <Dropdown
            isOpen={contextMenuOpen}
            toggle={() => setContextMenuOpen(!contextMenuOpen)}

          >
            <DropdownToggle className="p-0 bg-white">
              <i className="mdi mdi-dots-horizontal"></i>{" "}
            </DropdownToggle>
            <DropdownMenu className="custom-position">

              {options.showDelete &&
                <DropdownItem className="custom-position"
                              onClick={options?.onDelete}>
                  <span>
                    <i className="far fa-trash-alt font-size-15 me-1"></i>
                  </span>{" "}
                  Delete
                </DropdownItem>
              }

              {options.showRollOverToNextSession &&
                <DropdownItem className="custom-position"
                              onClick={options?.onRollOverToNextSession}>
                  <span>
                    <i className="mdi mdi-calendar-arrow-right font-size-15 me-1"></i>
                  </span>{" "}
                  Roll over to next session
                </DropdownItem>
              }

              {options.onAddNextActivity && <>
                <DropdownItem className="custom-position"
                              onClick={options?.onAddNextActivity}>
                  <span>
                    <i className="mdi mdi-skip-next font-size-15 me-1"></i>
                  </span>{" "}
                  Add the next activity
                </DropdownItem>
                </>
              }

              {options.onAddNextActivityToHomework && <>
                <DropdownItem className="custom-position"
                              onClick={options?.onAddNextActivityToHomework}>
                  <span>
                    <i className="mdi mdi-skip-next font-size-15 me-1"></i>
                  </span>{" "}
                  Add the next activity to homework
                </DropdownItem>
                </>
              }

            </DropdownMenu>
          </Dropdown>
        }
      </div>
    </div>
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center font-size-12 text-dark fw-400">
      </div>

      <div className="d-flex align-items-center font-size-12 text-dark fw-400">
        {" "}
        <img className="me-10" width={24} src={awicon} alt=""/>
        {activity.coins_earned ? activity.coins_earned: 0}
        /
        {total_coins}
        {" "}
      </div>
    </div>

  </div>
}